import {BooleanNumber} from "types";

export type JobPrep = {
    id: string;
    number_id: string;
    number_job: string;
    sales_order: string;
    date_due: string;
    fielder: string;
    category_id: string;
    category_name: string;
    type_id: string;
    type_name: string;
    district_id: string;
    district_name: string;
    requestor: string;
    is_priority: boolean;
    is_mre: boolean;
    is_katapult: boolean;
    kind_id: string;
    kind_name: string;
    department_id: string;
    department_name: string;
    source_id: string;
    source_name: string;
    status_id: string;
    status_name: string;
    date_due_fielding: string;
    project_id: string;
    project_name: string;
    waiting_subject_id: string | null;
    waiting_notes: string | null;
    waiting_ts: string;
    ts_created: string;
    cancel_notes: string | null;
    prep_notes: string | null;
    prep_reference_job_id: string | null;
    prep_reference_job_number_job: string;
    qc_notes: string | null;
    calcspec_notes: string | null;
    pole_total: number;
    employee_prep_list: Array<EmployeePrep>;
    percent_prep: number;
    department_owner_name: string;
    date_assigned_prep: string;
};

export type EmployeePrep = {
    employee_id: string;
    employee_name: string;
    pole_ids: string;
    pole_sequences: string;
    isStatic: boolean;
}

export type MainJobPrep = {
    id: string;
    number_id: string;
    number_job: string;
    sales_order: string;
    date_due: string;
    fielder: string;
    category_id: string;
    category_name: string;
    type_id: string;
    type_name: string;
    district_id: string;
    district_name: string;
    requestor: string;
    is_priority: boolean;
    is_mre: boolean;
    is_katapult: boolean;
    kind_id: string;
    kind_name: string;
    department_id: string;
    department_name: string;
    source_id: string;
    source_name: string;
    status_id: string;
    status_name: string;
    date_due_fielding: string;
    project_id: string;
    project_name: string;
    waiting_subject_id: string | null;
    waiting_notes: string | null;
    waiting_ts: string;
    ts_created: string;
    cancel_notes: string | null;
    prep_notes: string | null;
    prep_reference_job_id: string | null;
    prep_reference_job_number_job: string;
    qc_notes: string | null;
    calcspec_notes: string | null;
    pole_total: number;
    department_owner_name: string;
}

export type GetPrepListRequest = {
    id?: string;
    skip?: string | number;
    take?: string | number;
};

export type GetMainPrepListRequest = {
    employee_id?: string;
    skip?: string | number;
    take?: string | number;
};

export type InputGetJob = {
    range_start: number;
    range_end: number;
    date_due: Date;
    employee_id: string;
}

// export type JobPrepGetRequest = {
//     id: string;
//     range_start: number;
//     range_end: number;
//     date_due?: string;
// }

export type JobPrepGetRequest = {
    id: string;
    employee_id: string;
    date_due?: string;
    pole_id_list: Array<string>;
}

export type InputJobPrep = {
    id?: string;
    number_id: string;
    number_job: string;
    sales_order: string;
    date_due: Date;
    date_due_fielding: Date;
    fielder: string;
    category_id: string;
    type_id: string;
    district_id: string;
    project_id: string;
    requestor: string;
    is_priority: BooleanNumber;
    is_mre: BooleanNumber;
    is_katapult: BooleanNumber;
    kind_id: string;
    department_id: string;
    source_id: string;
    pole_total?: string;
    local_files: Array<File>;
    isEdit: boolean;
    status_id?: string;
};

export type UserGetPole = {
    employee_id: string,
    employee_name: string,
    seq_end: string,
    seq_start: string;
    pole_sequences: string;
    pole_ids: string;
}

export type JobPrepSummary = {
    employee_id: string;
    employee_name: string;
    total: number;
    date_due: string;
}

export enum JobPrepColumnSort
{
    project_name,
    department_name,
    kind_job,
    request_date,
    number_id,
    number_job,
    other_number,
    status,
    due_date,
    date_assign,
    req_pole,
    ready_in,
    date_ready
}

export enum JobMainPrepColumnSort
{
    project_name,
    department_name,
    kind_job,
    request_date,
    number_id,
    number_job,
    status,
    due_date,
    date_assign,
    req_pole
}

export enum SortingEnum {
    Ascending,
    Descending
}

export type GetPrepRequest = {
    project_name?: string;
    department_name?: string;
    kind_job?: string;
    startRequestDate?: string;
    endRequestDate?: string;
    number_id?: string;
    number_job?: string;
    other_number?: string;
    po_number?: string;
    status?: string;
    startDueDate?: string;
    endDueDate?: string;
    startDateAssign?: string;
    endDateAssign?: string;
    req_pole?: number;
    ready_in?: string;
    startDateReady?: string;
    endDateReady?: string;
    column?: JobPrepColumnSort;
    sort?: SortingEnum;
    skip: number;
    take: number;
}

export type GetPrepMainRequest = {
    project_name?: string;
    department_name?: string;
    kind_job?: string;
    startRequestDate?: string;
    endRequestDate?: string;
    number_id?: string;
    number_job?: string;
    other_number?: string;
    status?: string;
    startDateAssign?: string;
    endDateAssign?: string;
    startDueDate?: string;
    endDueDate?: string;
    req_pole?: number;
    column?: JobMainPrepColumnSort;
    sort?: SortingEnum;
    employee_id: string;
    skip: number;
    take: number;
}